



































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import { ReceivableApi,CustomerBase } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        DataPanel,
        SearchPanel,
        PaginationPanel,
        DraggerImg,
        collapse,
        ListFilterPanel,
    },
})
export default class ReceivableStatement extends Vue {
  public searchValue: ReceivableApi.GetReceivableBillListPayload = {
        status:'',
        billCode: '',
        billCycle: '',
        customerBaseName: '',
        asc: true,
        orderBy: '',
        creationStartTime: '',
        creationEndTime: ''
    };
    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
        formData: HTMLFormElement;
    };
    public dialogVisible: boolean = false;

    public formData: ReceivableApi.AddReceivableBillVM = {
        customerBaseId: '',
        cycle: [],
        preCollectionDate: ''
    };

    public formRules = formRules;

    public shipStateType = enums.auditStatusEnum2;

    public isActive: boolean = false;

    public loading: boolean = false;

    public rePagin: boolean = false;

    public total: number = 0;

    public tableData:Array<ReceivableApi.ReceivableBillListItemVM> = [];
    /**
     * 获取费用类型
     */
    public feeTypeList = [];

    public accountDateList = [];

    public departmentlist = [];

    public timeList = [];
    public created() {}
    public mounted() {
        if (sessionStorage.getItem('ReceivableStatement_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('ReceivableStatement_searchValue'));
            this.timeList = [this.searchValue.creationStartTime, this.searchValue.creationEndTime];
            this.searchPagin = sessionStorage.getItem('ReceivableStatement_page')
                ? JSON.parse(sessionStorage.getItem('ReceivableStatement_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('ReceivableStatement_page')
                ? JSON.parse(sessionStorage.getItem('ReceivableStatement_page'))
                : this.searchPagin;

            this.loadData();
        }
    }
    public colData = JSON.parse(localStorage.getItem('ReceivableStatement'))
        ? JSON.parse(localStorage.getItem('ReceivableStatement'))
        : [
              { title: '账单状态', isShow: true, disabled: false },
              { title: '账单编号', isShow: true, disabled: false },
              { title: '对账周期', isShow: true, disabled: false },
              { title: '客户/基地名称', isShow: true, disabled: false },
              { title: '账单总金额（元）', isShow: true, disabled: false },
              { title: '含税金额（元）', isShow: true, disabled: false },
              { title: '客诉（元）', isShow: true, disabled: false },
              { title: '其他（元）', isShow: true, disabled: false },
              { title: '创建人', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('ReceivableStatement', JSON.stringify(this.colData));
    }
    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('ReceivableStatement_searchValue', JSON.stringify(this.searchValue));
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('ReceivableStatement_page', JSON.stringify(pagin));
        this.loadData();
    }
    public resetSearchValue() {
        this.searchValue = {
            status:'',
            billCode: '',
            billCycle: '',
            customerBaseName: '',
            asc: true,
            orderBy: '',
            creationStartTime: '',
            creationEndTime: ''
        };
        this.timeList = [];
        this.searchFunc();
    }

    async getShipList(){
       let list = await CustomerBase.GetDropDownList({name:''});
       this.departmentlist = list;
    }

        /**
     * 日期转换
     */
    public billCycleChange(value) {
        if (value) {
            let MM = value.getMonth() + 1;
            if (MM < 10) {
                MM = '0' + MM;
            }
            this.searchValue.billCycle = value.getFullYear() + '-' + MM;
        } else {
            this.searchValue.billCycle = null;
        }
    }

    public async loadData() {
        this.loading = true;
        try {
            let skip = this.searchPagin.skip;
            let res = await ReceivableApi.GetReceivableBillList({
                ...this.searchValue,
                skip: skip,
                count: this.searchPagin.count
            });
            this.tableData = res.data;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item,index)=>{
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch (error) {
            this.loading = false;
        }
    }
    public datetimerange(v) {
        if (v) {
            this.searchValue.creationStartTime = v[0];
            this.searchValue.creationEndTime = v[1];
        } else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'creationTime':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
        }
        this.loadData();
    }


    /**新增对账单 */
    public datetimerangeChange(value) {
        this.formData.cycle = [];
        if (value) {
            this.getMonthBetween(value[0], value[1]);
            console.log(this.formData.cycle);
        } else {
            this.formData.cycle = [];
        }
    }
    //获取两月份之间所有月份方法
    getMonthBetween(start, end) {
        var result = [];
        var newResult = [];
        var starts = start.split('-');
        var ends = end.split('-');
        var staYear = parseInt(starts[0]);
        var staMon = parseInt(starts[1]);
        var endYear = parseInt(ends[0]);
        var endMon = parseInt(ends[1]);
        while (staYear <= endYear) {
            if (staYear === endYear) {
                while (staMon < endMon) {
                    staMon++;
                    result.push({ year: staYear, month: staMon });
                }
                staYear++;
            } else {
                staMon++;
                if (staMon > 12) {
                    staMon = 1;
                    staYear++;
                }
                result.push({ year: staYear, month: staMon });
            }
        }

        for (var i = 0; i < result.length; i++) {
            var year = result[i].year;
            var monthinit = result[i].month;
            var month = monthinit;
            //补'0'操作
            if (monthinit < 10) {
                month = '0' + monthinit;
            } else {
                month = monthinit + '';
            }
            var ym = year + '-' + month;
            this.formData.cycle.push(ym);
        }
        this.formData.cycle.unshift(start);
        return this.formData.cycle;
    }
    public addBtn() {
        this.formData = {
            customerBaseId: '',
            cycle: [],
            preCollectionDate: ''
        }
        this.accountDateList = [];
        this.getShipList();
        this.dialogVisible = true;
    }
    public handleClose() {
        this.$refs.formData.resetFields();
        this.dialogVisible = false;
    }
    public save() {
         this.$refs.formData.validate(async (valid) => {
             if(valid){
                 ReceivableApi.AddReceivableBill(this.formData).then(res=>{
                    this.dialogVisible = false;
                     this.$router.push({
                            path: '/receivableStatementDetails',
                            query: {
                                id: res.extData,
                            },
                        });
                 })
                 
             }
         })
    }
    public async exportExcel() {
        let data = await ReceivableApi.GetReceivableExportlist({
              ...this.searchValue,
              skip: this.searchPagin.skip,
              count: this.searchPagin.count
        });
    }
    public toSkip(row){
        sessionStorage.setItem('ReceivableStatement_page', JSON.stringify(this.searchPagin));
        this.$router.push({
            path: '/receivableStatementDetails',
            query: {
                id: row.id,
            },
        });
    }
        public getBillColor(val) {
        switch (val) {
            case '待审核':
                return 'c_blue';
            case '已审核':
                return 'c_green';

            default:
                break;
        }
    }
    async querySearch(queryString, cb) {
        let res = await CustomerBase.GetDropDownList({ name: this.searchValue.customerBaseName});
        let result = [];
        res.forEach((dd) => {
            let xx = {
                value: dd.customerBaseName,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    selecShip(data) {
        this.searchValue.customerBaseName = data.value;
    }

    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig.show = false;
    }
        /**通过 */
    public srow: any;
    public srowTy: string = '';
    public setColor: boolean = false;
    through(row) {
        this.setColor = false;
        this.srow = row;
        this.srowTy = 'a';
        this.dialogConfig = {
            title: '审核通过对账单',
            show: true,
        };
    }
    async confirmOk() {
        ReceivableApi.AuditPass(this.srow.id).then((res) => {
            this.$message({
                type: 'success',
                message: '账单审核通过！',
            });
           this.loadData();
        this.dialogConfig.show = false;
        })
    }
}
